<!-- Start Sign up Area -->
<div class="sign-up-area ptb-100">
  <div class="container">
    <div class="section-title">
      <h2>Create an Account!</h2>
    </div>

    <div class="sign-up-form">
      <form>
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="first_name"
                placeholder="First name"
              />
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                id="last_name"
                placeholder="Last name"
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="username"
            placeholder="Enter your Username"
            #username
          />
        </div>

        <div class="form-group">
          <input
            type="email"
            class="form-control"
            id="email"
            placeholder="Email Address"
            #email
          />
        </div>

        <div class="form-group">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Password"
            #password
          />
        </div>

        <div class="form-group">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Confirm Password"
          />
        </div>

        <div class="form-group">
          <select id="role" class="form-control" #role>
            <option value="Employee">Employee</option>
            <option value="Admin">Admin</option>
          </select>
        </div>

        <div class="text-center">
          <ng-container
            *ngIf="this.authFacade.loading$ | async; else submitButton"
          >
            <button type="button" class="btn default-btn-one">
              <mat-spinner [diameter]="24"></mat-spinner>
            </button>
          </ng-container>
          <ng-template #submitButton>
            <button
              type="button"
              class="btn default-btn-one"
              (click)="onSubmit(username, password, email, role)"
            >
              Sign Up
            </button>
          </ng-template>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- End Sign up  Area -->
